module.exports = __webpack_public_path__ + "img/Feature.478bf059.png";